import { APP_LINK_TYPE, APP_LINK_TYPE_TEXT } from '../common/commonConstants';

/**
 *  원격 이미지 관리 > 스플래시 이미지 페이지 이름
 */
export const REMOTE_SPLASH_IMAGE_PAGE_NAME = {
  REMOTE_SPLASH_IMAGE_LIST: '스플래시 이미지 리스트',
  REMOTE_SPLASH_IMAGE_CREATE: '스플래시 이미지 등록',
  REMOTE_SPLASH_IMAGE_EDIT: '스플래시 이미지 수정',
};

/**
 *  원격 이미지 관리 > 레퍼럴 이미지 페이지 이름
 */
export const REMOTE_REFERRAL_IMAGE_PAGE_NAME = {
  REMOTE_REFERRAL_IMAGE_LIST: '레퍼럴 이미지 리스트',
  REMOTE_REFERRAL_IMAGE_CREATE: '레퍼럴 이미지 등록',
  REMOTE_REFERRAL_IMAGE_EDIT: '레퍼럴 이미지 수정',
};

/**
 *  원격 이미지 관리 상세 페이지 타입
 */
export const REMOTE_IMAGE_DETAIL_PAGE_TYPE = {
  CREATE: 0,
  EDIT: 1,
};

/**
 *  원격 이미지 관리 상세 페이지에서 메모 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_REMOTE_IMAGE_DETAIL_MEMO = 1000;

/**
 *  원격 이미지 최대 개수
 */
export const MAXIMUM_NUMBER_OF_REMOTE_IMAGE = 1;

/**
 *  원격 이미지 최소 개수
 */
export const MINIMUM_NUMBER_OF_REMOTE_IMAGE = 1;

/**
 *  원격 스플래시 이미지 넓이
 */
export const REMOTE_SPLASH_IMAGE_WIDTH = 1200;

/**
 *  원격 스플래시 이미지 높이
 */
export const REMOTE_SPLASH_IMAGE_HEIGHT = 2500;

/**
 *  원격 스플래시/레퍼럴 이미지 리스트 메모 검색 최대 길이
 */
export const MAXIMUM_NUMBER_OF_REMOTE_IMAGE_LIST_SEARCH_MEMO = 100;

/**
 *  원격 레퍼럴 이미지 노출위치 타입
 */
export const REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE = {
  /**
   *  마이페이지
   */
  MY_PAGE: 0,
  /**
   *  레퍼럴상세
   */
  REFERRAL_DETAIL: 1,
};

/**
 *  원격 레퍼럴 이미지 텍스트
 */
export const REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE_TEXT = {
  [REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE.MY_PAGE]: '마이페이지',
  [REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE.REFERRAL_DETAIL]: '레퍼럴상세',
};

/**
 *  원격 레퍼럴 이미지 SELECT LIST
 */
export const REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE_SELECT_LIST = [
  {
    id: REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE.MY_PAGE,
    name: REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE_TEXT[REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE.MY_PAGE],
  },
  {
    id: REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE.REFERRAL_DETAIL,
    name: REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE_TEXT[REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE.REFERRAL_DETAIL],
  },
];

/**
 *  원격 레퍼럴 이미지 타입
 */
export const REMOTE_REFERRAL_IMAGE_TYPE = {
  /**
   *  App 이미지
   */
  APP: 0,
  /**
   *  PC 이미지
   */
  PC: 1,
  /**
   *  Tablet 이미지
   */
  TABLET: 2,
  /**
   *  Mobile 이미지
   */
  MOBILE: 3,
};

/**
 *  원격 레퍼럴 이미지 타입 텍스트
 */
export const REMOTE_REFERRAL_IMAGE_TYPE_TEXT = {
  /**
   *  App 이미지
   */
  [REMOTE_REFERRAL_IMAGE_TYPE.APP]: 'App 이미지',
  /**
   *  PC 이미지
   */
  [REMOTE_REFERRAL_IMAGE_TYPE.PC]: 'PC 이미지',
  /**
   *  Tablet 이미지
   */
  [REMOTE_REFERRAL_IMAGE_TYPE.TABLET]: 'Tablet 이미지',
  /**
   *  Mobile 이미지
   */
  [REMOTE_REFERRAL_IMAGE_TYPE.MOBILE]: 'Mobile 이미지',
};

/**
 *  원격 레퍼럴 마이페이지 App 이미지 제플린 링크
 */
export const REMOTE_REFERRAL_MYPAGE_APP_IMAGE_ZEPLIN_URL =
  'https://app.zeplin.io/project/5b95de9cd374679ce5dcbe7c/screen/5f6b243da5db7617665e9e31';

/**
 *  원격 레퍼럴 마이페이지 Pc 이미지 제플린 링크
 */
export const REMOTE_REFERRAL_MYPAGE_PC_IMAGE_ZEPLIN_URL =
  'https://app.zeplin.io/project/5ec5f50142eea12be7b6689c/screen/5f1e3686df3b2246a02af364';

/**
 *  원격 레퍼럴 마이페이지 Tablet 이미지 제플린 링크
 */
export const REMOTE_REFERRAL_MYPAGE_TABLET_IMAGE_ZEPLIN_URL =
  'https://app.zeplin.io/project/5ec5f4eaa0e19b2c0bed4767/screen/5f8ebd161b3ae68326c37f46';

/**
 *  원격 레퍼럴 마이페이지 Mobile 이미지 제플린 링크
 */
export const REMOTE_REFERRAL_MYPAGE_MOBILE_IMAGE_ZEPLIN_URL =
  'https://app.zeplin.io/project/5ec5f48464b54745ed99e17b/screen/5f8ebe4e26d46e60137b9cd2';

/**
 *  원격 레퍼럴 상세 App 이미지 제플린 링크
 */
export const REMOTE_REFERRAL_DETAIL_APP_IMAGE_ZEPLIN_URL =
  'https://app.zeplin.io/project/5b95de9cd374679ce5dcbe7c/screen/5f6b2437541f780e5c8e93e7';

/**
 *  원격 레퍼럴 Pc 이미지 제플린 링크
 */
export const REMOTE_REFERRAL_DETAIL_PC_IMAGE_ZEPLIN_URL =
  'https://app.zeplin.io/project/5ec5f50142eea12be7b6689c/screen/5f9a28f6e58db245d579b260';

/**
 *  원격 레퍼럴 Tablet 이미지 제플린 링크
 */
export const REMOTE_REFERRAL_DETAIL_TABLET_IMAGE_ZEPLIN_URL =
  'https://app.zeplin.io/project/5ec5f4eaa0e19b2c0bed4767/screen/5f9a514001719cb914d1d0f3';

/**
 *  원격 레퍼럴 Mobile 이미지 제플린 링크
 */
export const REMOTE_REFERRAL_DETAIL_MOBILE_IMAGE_ZEPLIN_URL =
  'https://app.zeplin.io/project/5ec5f48464b54745ed99e17b/screen/5f9a562b5cf466b46e1dcaee';

/**
 *  원격 레퍼럴 링크 타입
 */
export const REMOTE_REFERRAL_LINK_TYPE = {
  REFERRAL_DETAIL: APP_LINK_TYPE.REFERRAL,
};

/**
 *  원격 레퍼럴 링크 타입
 */
export const REMOTE_REFERRAL_LINK_TYPE_TEXT = {
  [REMOTE_REFERRAL_LINK_TYPE.REFERRAL_DETAIL]: APP_LINK_TYPE_TEXT[REMOTE_REFERRAL_LINK_TYPE.REFERRAL_DETAIL],
};

/**
 *  원격 레퍼럴 링크 타입 SELECT LIST
 */
export const REMOTE_REFERRAL_LINK_TYPE_SELECT_LIST = [
  {
    id: REMOTE_REFERRAL_LINK_TYPE.REFERRAL_DETAIL,
    name: REMOTE_REFERRAL_LINK_TYPE_TEXT[REMOTE_REFERRAL_LINK_TYPE.REFERRAL_DETAIL],
  },
];

/**
 *  원격 이미지 활성상태 타입
 */
export const REMOTE_IMAGE_ACTIVE_STATUS_TYPE = {
  IN_ACTIVE: 0,
  ACTIVE: 1,
};

/**
 *  원격 이미지 활성상태 타입 텍스트
 */
export const REMOTE_IMAGE_ACTIVE_STATUS_TYPE_TEXT = {
  [REMOTE_IMAGE_ACTIVE_STATUS_TYPE.IN_ACTIVE]: '비활성',
  [REMOTE_IMAGE_ACTIVE_STATUS_TYPE.ACTIVE]: '활성',
};

/**
 *  원격 이미지 활성상태 타입 SELECT LIST
 */
export const REMOTE_IMAGE_ACTIVE_STATUS_TYPE_SELECT_LIST = [
  {
    id: REMOTE_IMAGE_ACTIVE_STATUS_TYPE.IN_ACTIVE,
    name: REMOTE_IMAGE_ACTIVE_STATUS_TYPE_TEXT[REMOTE_IMAGE_ACTIVE_STATUS_TYPE.IN_ACTIVE],
  },
  {
    id: REMOTE_IMAGE_ACTIVE_STATUS_TYPE.ACTIVE,
    name: REMOTE_IMAGE_ACTIVE_STATUS_TYPE_TEXT[REMOTE_IMAGE_ACTIVE_STATUS_TYPE.ACTIVE],
  },
];

/**
 *  원격 이미지 타입
 */
export const REMOTE_IMAGE_TYPE = {
  SPLASH: 0,
  REFERRAL: 1,
};

/**
 *  원격 이미지 타입
 */
export const REMOTE_IMAGE_TYPE_TEXT = {
  [REMOTE_IMAGE_TYPE.SPLASH]: '스플래시',
  [REMOTE_IMAGE_TYPE.REFERRAL]: '레퍼럴',
};
